module.exports = __webpack_public_path__ + "static/dummy.1-6ea49389d8ee6607eed76cc4ecb14ab8.png";